import { Modal, use_modal } from '@/components/modal';
import { api_DoExchange } from "@/api";
import Picture from '@/components/picture';
import InteractivePanel from '@/components/interactive_panel';
import {
	mapState, mapMutations
} from "vuex";


export default {

	components: {
		'c-picture': Picture,
		'c-modal': Modal,
		'c-interactive-panel': InteractivePanel,
	},


	data() {
		return {
			/** 侧边栏是否显示 */
			is_sidebar_show: true,
			exchange: {
				is_modal_show: false,
				exchangeCode: '',
				otp: '',
			},
		};
	},


	computed: {
		...mapState([
			'GobalInfo',
			'tradeOfferBox',
			'user'
		]),
		active_offer_count() {
			return this.tradeOfferBox.list.filter(_ => _.state == 1 || _.state == 2).length;
		}

	},
	created() {
		if (this.$screen.mobile)
			this.is_sidebar_show = false;
	},
	methods: {
		...mapMutations([
			"switch_tradeofferbox_show",
			"RequestTradeOffer"
		]),
		/** 切换侧边栏显示状态 */
		async toggle_sidebar_show() {
			this.is_sidebar_show = !this.is_sidebar_show;
		},
		/** 打开客服窗口 */
		async open_service_window(e) {
			e.preventDefault()

			let myWindow = window.open(
				'/dialog_1.htm',
				`${this.$t('site_name')}客服会话`,
				'width=1000,height=800,toolbar=yes,menubar=yes,location=no,resizable=yes,scrollbars=true,status=true'
			)

			myWindow.focus();
		},
		clickWelfare(welfareCat) {
			this.$emit("on_welfareclick", welfareCat);
		},
		showModal(bool) {
			this.exchange.is_modal_show = true;
		},
		doExchange() {
			if (this.exchange.exchangeCode == '' || this.exchange.otp == '') {
				this.$Message.error('输入信息不全');
				return;
			}
			api_DoExchange({ exchangeCode: this.exchange.exchangeCode, otp: this.exchange.otp }).then(res => {
				if (res.code == 0) {
					this.$Message.success('兑换成功');
					this.exchange.is_modal_show = false;
					this.exchange.exchangeCode = '';
					this.exchange.otp = '';
				} else {
					this.$Message.error(res.msg);
				}
			});
		}
	},

};
